import { BuildOutlined, SyncOutlined, CheckCircleOutlined, FileTextOutlined } from '@ant-design/icons';

const icons = {
  BuildOutlined,
  SyncOutlined,
  CheckCircleOutlined,
  FileTextOutlined
};

const produksi = {
  id: 'group-produksi',
  title: 'Produksi',
  type: 'group',
  children: [
    {
      id: 'produksi-proses',
      title: 'Proses Produksi & Pemilahan',
      type: 'item',
      url: '/produksi/proses',
      icon: icons.SyncOutlined
    },
    {
      id: 'produksi-finish-good',
      title: 'Finish Good',
      type: 'item',
      url: '/produksi/finish-good',
      icon: icons.CheckCircleOutlined
    },
    {
      id: 'laporan-finish-good',
      title: 'Laporan Finish Good',
      type: 'item',
      url: '/produksi/laporan-finish-good',
      icon: icons.FileTextOutlined
    }
  ]
};

export default produksi;
